import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'sarsaparilla';
import RenderIf from '../../utils/JSXUtils';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  validator: PropTypes.func,
  isValid: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
  showError: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  disabled: false,
  validator: () => false,
  isValid: true,
  error: false,
  showError: true,
  required: false,
  label: "Select an option"
};

export default class SelectInput extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isValid: this.props.isValid,
      error: this.props.error
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isValid !== this.props.isValid) {
      this.setState((prevState) => ({ ...prevState, isValid: nextProps.isValid, error: nextProps.error }));
    }
  }

  onChange(value) {
    const error = this.props.validator(value);
    const isValid = !error;

    this.setState((prevState) => ({ ...prevState, isValid, error }), () => {
      if (this.props.onChange) {
        this.props.onChange(value, isValid, error);
      }
    });
  }

  render() {
    const { id, label, value, options, className, disabled, required, showError } = this.props;
    const { isValid, error } = this.state;
    const classes = `rec-form-item-wrap ${className}`;

    return (
      <div className={classes}>
        <Dropdown
          label={label}
          isRequired={required}
          id={id}
          options={options}
          changeSelection={this.onChange}
          currentSelection={value}
          className={!isValid ? 'rec-error' : ''}
          disabled={disabled} />
        {RenderIf(showError && !isValid)(<div>{error}</div>)}
      </div>
    );
  }
}

SelectInput.propTypes = propTypes;
SelectInput.defaultProps = defaultProps;
